<template>
  <div class="tianfulove">
    <div class="leftBox" :class="{ 'hidden': isMobile }">
      <el-menu
        :default-active="defaultActive"
        class="el-menu-vertical-demo"
        @select="handleSelect"
        @open="handleOpen"
        @close="handleClose"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-menu-item index="user" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">用户列表</span>
        </el-menu-item>
        <el-menu-item index="activity" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">活动列表</span>
        </el-menu-item>
        <el-menu-item index="carousel" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">轮播列表</span>
        </el-menu-item>
        <el-menu-item index="article" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">文章列表</span>
        </el-menu-item>
        <el-menu-item index="order" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">订单列表</span>
        </el-menu-item>
        <el-menu-item index="selfPoint" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">自提点列表</span>
        </el-menu-item>
        <el-menu-item index="tixian" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">提现列表</span>
        </el-menu-item>
        <el-menu-item index="classify" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">分类列表</span>
        </el-menu-item>
        <el-menu-item index="mahjong">
          <i class="el-icon-menu"></i>
          <span slot="title">麻将桌列表</span>
        </el-menu-item>
        <el-menu-item index="jifen" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">积分列表</span>
        </el-menu-item>
        <el-menu-item index="config" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">基本设置</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="mobile-toggle" @click="toggleMobileMenu" v-if="isMobile">
      <i class="el-icon-menu"></i>
    </div>
    <div class="rightBox" :class="{ 'mobile-full': isMobile }">
      <router-view />
    </div>
    <div class="mobile-menu-overlay" v-if="showMobileMenu" @click="showMobileMenu = false"></div>
    <div class="mobile-menu" :class="{ 'show': showMobileMenu }">
      <el-menu
        :default-active="defaultActive"
        class="el-menu-vertical-demo mobile-menu-inner"
        @select="handleMobileSelect"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-menu-item index="user" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">用户列表</span>
        </el-menu-item>
        <el-menu-item index="activity" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">活动列表</span>
        </el-menu-item>
        <el-menu-item index="carousel" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">轮播列表</span>
        </el-menu-item>
        <el-menu-item index="article" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">文章列表</span>
        </el-menu-item>
        <el-menu-item index="order" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">订单列表</span>
        </el-menu-item>
        <el-menu-item index="selfPoint" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">自提点列表</span>
        </el-menu-item>
        <el-menu-item index="tixian" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">提现列表</span>
        </el-menu-item>
        <el-menu-item index="classify" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">分类列表</span>
        </el-menu-item>
        <el-menu-item index="mahjong">
          <i class="el-icon-menu"></i>
          <span slot="title">麻将桌列表</span>
        </el-menu-item>
        <el-menu-item index="jifen" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">积分列表</span>
        </el-menu-item>
        <el-menu-item index="config" v-if="power==='1'">
          <i class="el-icon-menu"></i>
          <span slot="title">基本设置</span>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      power:'2',
      defaultActive: "user",
      isMobile: false,
      showMobileMenu: false,
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(name) {
      this.$router.push({
        name,
      });
    },
    handleMobileSelect(name) {
      this.$router.push({ name });
      this.showMobileMenu = false;
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
  },
  mounted() {
    this.defaultActive = this.$route.name;
    this.power = localStorage.getItem('power');
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
};
</script>

<style lang="less">
.tianfulove {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  .leftBox {
    width: 10%;
    min-width: 130px;
    &.hidden {
      display: none;
    }
  }
  .mobile-toggle {
    position: fixed;
    top: 10px;
    left: 10px;
    width: 40px;
    height: 40px;
    background: #545c64;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    z-index: 100;
    font-size: 20px;
  }
  .rightBox {
    flex: 1;
    background: #fff;
    overflow-y: auto;
    padding: 20px;
    &.mobile-full {
      width: 100%;
      padding: 60px 10px 20px;
    }
    .fenye {
      text-align: right;
      padding: 15px 10px;
    }
  }
  .mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 200;
  }
  .mobile-menu {
    position: fixed;
    top: 0;
    left: -200px;
    width: 200px;
    height: 100%;
    background: #545c64;
    z-index: 300;
    transition: left 0.3s ease;
    &.show {
      left: 0;
    }
    .mobile-menu-inner {
      border-right: none;
      height: 100%;
    }
  }
}

@media screen and (max-width: 768px) {
  .tianfulove .leftBox {
    display: none;
  }
  .tianfulove .rightBox {
    width: 100%;
    padding: 60px 10px 20px;
  }
}
</style>
